import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Box,
  Chip,
  MenuItem,
  Menu,
  Button,
  Tooltip,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/ArrowDropDown";
import KeyboardArrowUpIcon from "@mui/icons-material/ArrowDropUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AppsIcon from "@mui/icons-material/Apps";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckIcon from "@mui/icons-material/Check";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Label from "../../../components/Label/Label";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

export default function ParameterTable({ data, onVisibilityClick, handleApprove, handleMenuOption, handleClose, handleReorderColumn }) {
  const [openRow, setOpenRow] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState();
  const [menuPosition, setMenuPosition] = useState(null);
  const open = Boolean(menuPosition);
  useEffect(() => {
    setTableData(data?.data?.results);
  }, [data]);

  const toggleExpand = (id) => {
    setOpenRow(openRow === id ? null : id);
  };

  const handleClick = (event, row, param) => {
    event.stopPropagation();

    setSelectedRow({ row, param });

    setMenuPosition({
      mouseX: event.clientX - 20,
      mouseY: event.clientY + 10,
    });
  };

  /* ================= SORTABLE ROW ================= */
  function SortableRow({ id, children }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({ id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    return (
      <TableRow
        ref={setNodeRef}
        style={style}
      >
        {/* <TableCell
          sx={{ width: 40, cursor: "grab", textAlign: "center" }}
          {...attributes}
          {...listeners}
        >
          <AppsIcon fontSize="small" />
        </TableCell> */}

        <TableCell > </TableCell>
        {children}
      </TableRow>
    );
  }

  /* ================= DRAG HANDLER ================= */
  // const handleDragEnd = (event, rowId, level, phaseName, tableName) => {
  //   const { active, over } = event;
  //   if (!over || active.id === over.id) return;

  //   setTableData((prev) =>
  //     prev.map((row) => {
  //       if (row.unit_op_id !== rowId) return row;

  //       /* -------- TABLE LEVEL -------- */
  //       if (level === "table") {
  //         return {
  //           ...row,
  //           phases: row.phases.map((phase) => {
  //             if (phase.phase_name !== phaseName) return phase;

  //             return {
  //               ...phase,
  //               tables: phase.tables.map((table) => {
  //                 if (table.table_name !== tableName) return table;

  //                 const oldIndex = table.parameters.findIndex(
  //                   (p) => p.parameter_id === active.id
  //                 );
  //                 const newIndex = table.parameters.findIndex(
  //                   (p) => p.parameter_id === over.id
  //                 );

  //                 return {
  //                   ...table,
  //                   parameters: arrayMove(
  //                     table.parameters,
  //                     oldIndex,
  //                     newIndex
  //                   ),
  //                 };
  //               }),
  //             };
  //           }),
  //         };
  //       }

  //       /* -------- PHASE LEVEL -------- */
  //       if (level === "phase") {
  //         return {
  //           ...row,
  //           phases: row.phases.map((phase) => {
  //             if (phase.phase_name !== phaseName) return phase;

  //             const oldIndex = phase.parameters.findIndex(
  //               (p) => p.parameter_id === active.id
  //             );
  //             const newIndex = phase.parameters.findIndex(
  //               (p) => p.parameter_id === over.id
  //             );

  //             return {
  //               ...phase,
  //               parameters: arrayMove(
  //                 phase.parameters,
  //                 oldIndex,
  //                 newIndex
  //               ),
  //             };
  //           }),
  //         };
  //       }

  //       /* -------- UNIT LEVEL -------- */
  //       if (level === "unit") {
  //         const oldIndex = row.parameters.findIndex(
  //           (p) => p.parameter_id === active.id
  //         );
  //         const newIndex = row.parameters.findIndex(
  //           (p) => p.parameter_id === over.id
  //         );

  //         return {
  //           ...row,
  //           parameters: arrayMove(row.parameters, oldIndex, newIndex),
  //         };
  //       }

  //       if (level === "unit-table") {
  //         return {
  //           ...row,
  //           tables: row.tables.map((table) => {
  //             if (table.table_name !== tableName) return table;

  //             const oldIndex = table.parameters.findIndex(
  //               (p) => p.parameter_id === active.id
  //             );
  //             const newIndex = table.parameters.findIndex(
  //               (p) => p.parameter_id === over.id
  //             );

  //             return {
  //               ...table,
  //               parameters: arrayMove(
  //                 table.parameters,
  //                 oldIndex,
  //                 newIndex
  //               ),
  //             };
  //           }),
  //         };
  //       }

  //       return row;
  //     })
  //   );
  // };


  const handleDragEnd = (event, rowId, level, phaseName, tableName) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setTableData((prev) =>
      prev.map((row) => {
        if (row.unit_op_id !== rowId) return row;

        let updatedRow = { ...row };

        /* -------- UNIT PARAMETERS -------- */
        if (level === "unit") {
          const oldIndex = row.parameters.findIndex(p => p.parameter_id === active.id);
          const newIndex = row.parameters.findIndex(p => p.parameter_id === over.id);

          updatedRow.parameters = arrayMove(row.parameters, oldIndex, newIndex);

          // Call API with new order
          const payload = {
            unit_op_id: row.unit_op_id,
            sheet_order: row.parameters[0]?.sheet_order, // keep existing or calculate
            parameters: updatedRow.parameters.map(p => p.parameter_id)
          };
          handleReorderColumn(payload);
        }

        /* -------- TABLE PARAMETERS -------- */
        if (level === "unit-table" || level === "table") {
          updatedRow.tables = row.tables.map(table => {
            if (table.table_name !== tableName) return table;

            const oldIndex = table.parameters.findIndex(p => p.parameter_id === active.id);
            const newIndex = table.parameters.findIndex(p => p.parameter_id === over.id);

            const updatedParameters = arrayMove(table.parameters, oldIndex, newIndex);

            // Call API with new order
            const payload = {
              unit_op_id: row.unit_op_id,
              sheet_order: table.parameters[0]?.sheet_order, // adjust if needed
              parameters: updatedParameters.map(p => p.parameter_id)
            };
            handleReorderColumn(payload);

            return { ...table, parameters: updatedParameters };
          });
        }

        /* -------- PHASE PARAMETERS -------- */
        if (level === "phase") {
          updatedRow.phases = row.phases.map(phase => {
            if (phase.phase_name !== phaseName) return phase;

            const oldIndex = phase.parameters.findIndex(p => p.parameter_id === active.id);
            const newIndex = phase.parameters.findIndex(p => p.parameter_id === over.id);

            const updatedParameters = arrayMove(phase.parameters, oldIndex, newIndex);

            const payload = {
              unit_op_id: row.unit_op_id,
              sheet_order: phase.parameters[0]?.sheet_order, // adjust if needed
              parameters: updatedParameters.map(p => p.parameter_id)
            };
            handleReorderColumn(payload);

            return { ...phase, parameters: updatedParameters };
          });
        }

        return updatedRow;
      })
    );
  };
  /* ================= RENDER ================= */
  const renderGroupedSections = (row) => (
    <>
      {/* ================= UNIT PARAMETERS ================= */}
      {row.parameters?.length > 0 && (
        <DndContext
          collisionDetection={closestCenter}
          onDragEnd={(event) =>
            handleDragEnd(event, row.unit_op_id, "unit")
          }
        >
          <SortableContext
            items={row.parameters.map((p) => p.parameter_id)}
            strategy={verticalListSortingStrategy}
          >
            {row.parameters.map((param) => (
              <SortableRow key={param.parameter_id} id={param.parameter_id}>
                <TableCell />
                <TableCell />
                <TableCell>{row.unit_op_name}</TableCell>
                <TableCell>{param.parameter_name}</TableCell>
                <TableCell>{param.unit_of_measure}</TableCell>
                <TableCell>{param.parameter_class}</TableCell>
                <TableCell>{param.source_system}</TableCell>
                <TableCell>{param.data_type}</TableCell>
                <TableCell sx={{ fontSize: 14 }}>
                  {param.description ? (
                    <Tooltip
                      title={
                        <Typography sx={{ fontSize: 13, maxWidth: 300 }}>
                          {param.description}
                        </Typography>
                      }
                      arrow
                      placement="top"
                      slotProps={{
                        tooltip: {
                          sx: {
                            backgroundColor: "#f5f5f5",   // light background
                            color: "#333",               // dark text
                            border: "1px solid #e0e0e0",
                            boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#f5f5f5",
                          },
                        },
                      }}
                    >
                      <DescriptionOutlinedIcon
                        sx={{
                          fontSize: 20,
                          color: "#9e9e9e",
                          cursor: "pointer",
                          "&:hover": { color: "#1976d2" },
                        }}
                      />
                    </Tooltip>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell sx={{ fontSize: 14 }}>
                  <Chip
                    label={param.status}
                    className={`status-chip ${param.status?.includes("active")
                      ? "status-chip-color-green"
                      : "status-chip-color-gray"
                      }`}
                  />
                </TableCell>
                <TableCell >
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();   // prevent drag conflict
                      handleClick(e, row, param);
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </TableCell>
              </SortableRow>
            ))}
          </SortableContext>
        </DndContext>
      )}

      {/* ===== PHASES ===== */}
      {row.tables?.length > 0 &&
        row.tables.map((table) => (
          <React.Fragment key={table.table_name}>
            <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
              {/* <TableCell /> */}
              <TableCell colSpan={12} sx={{ fontWeight: "bold" }}>
                Table - {table.table_name}
              </TableCell>
            </TableRow>

            {table.parameters?.length > 0 && (
              <DndContext
                collisionDetection={closestCenter}
                onDragEnd={(event) =>
                  handleDragEnd(
                    event,
                    row.unit_op_id,
                    "unit-table",
                    null,
                    table.table_name
                  )
                }
              >
                <SortableContext
                  items={table.parameters.map((p) => p.parameter_id)}
                  strategy={verticalListSortingStrategy}
                >
                  {table.parameters.map((param) => (
                    <SortableRow
                      key={param.parameter_id}
                      id={param.parameter_id}
                    >
                      <TableCell />
                      <TableCell />
                      <TableCell>{row.unit_op_name}</TableCell>
                      <TableCell>{param.parameter_name}</TableCell>
                      <TableCell>{param.unit_of_measure}</TableCell>
                      <TableCell>{param.parameter_class}</TableCell>
                      <TableCell>{param.source_system}</TableCell>
                      <TableCell>{param.data_type}</TableCell>
                      <TableCell sx={{ fontSize: 14 }}>
                        {param.description ? (
                          <Tooltip
                            title={
                              <Typography sx={{ fontSize: 13, maxWidth: 300 }}>
                                {param.description}
                              </Typography>
                            }
                            arrow
                            placement="top"
                            slotProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#f5f5f5",   // light background
                                  color: "#333",               // dark text
                                  border: "1px solid #e0e0e0",
                                  boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#f5f5f5",
                                },
                              },
                            }}
                          >
                            <DescriptionOutlinedIcon
                              sx={{
                                fontSize: 20,
                                color: "#9e9e9e",
                                cursor: "pointer",
                                "&:hover": { color: "#1976d2" },
                              }}
                            />
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell sx={{ fontSize: 14 }}>
                        <Chip
                          label={param.status}
                          className={`status-chip ${param.status?.includes("active")
                            ? "status-chip-color-green"
                            : "status-chip-color-gray"
                            }`}
                        />
                      </TableCell>
                      <TableCell >
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();   // prevent drag conflict
                            handleClick(e, row, param);
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </SortableRow>
                  ))}
                </SortableContext>
              </DndContext>
            )}
          </React.Fragment>
        ))}

      {/* ================= PHASES ================= */}
      {row.phases?.length > 0 &&
        row.phases.map((phase) => (
          <React.Fragment key={phase.phase_name}>
            <TableRow sx={{ backgroundColor: "#e6ebf2" }}>
              {/* <TableCell /> */}
              <TableCell colSpan={12} sx={{ fontWeight: "bold" }}>
                Phase - {phase.phase_name}
              </TableCell>
            </TableRow>

            {/* -------- PHASE PARAMETERS -------- */}
            {phase.parameters?.length > 0 && (
              <DndContext
                collisionDetection={closestCenter}
                onDragEnd={(event) =>
                  handleDragEnd(
                    event,
                    row.unit_op_id,
                    "phase",
                    phase.phase_name
                  )
                }
              >
                <SortableContext
                  items={phase.parameters.map((p) => p.parameter_id)}
                  strategy={verticalListSortingStrategy}
                >
                  {phase.parameters.map((param) => (
                    <SortableRow
                      key={param.parameter_id}
                      id={param.parameter_id}
                    >
                      <TableCell ></TableCell>
                      <TableCell />
                      <TableCell>{row.unit_op_name}</TableCell>
                      <TableCell>{param.parameter_name}</TableCell>
                      <TableCell>{param.unit_of_measure}</TableCell>
                      <TableCell>{param.parameter_class}</TableCell>
                      <TableCell>{param.source_system}</TableCell>
                      <TableCell>{param.data_type}</TableCell>
                      <TableCell sx={{ fontSize: 14 }}>
                        {param.description ? (
                          <Tooltip
                            title={
                              <Typography sx={{ fontSize: 13, maxWidth: 300 }}>
                                {param.description}
                              </Typography>
                            }
                            arrow
                            placement="top"
                            slotProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#f5f5f5",   // light background
                                  color: "#333",               // dark text
                                  border: "1px solid #e0e0e0",
                                  boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#f5f5f5",
                                },
                              },
                            }}
                          >
                            <DescriptionOutlinedIcon
                              sx={{
                                fontSize: 20,
                                color: "#9e9e9e",
                                cursor: "pointer",
                                "&:hover": { color: "#1976d2" },
                              }}
                            />
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell sx={{ fontSize: 14 }}>
                        <Chip
                          label={param.status}
                          className={`status-chip ${param.status?.includes("active")
                            ? "status-chip-color-green"
                            : "status-chip-color-gray"
                            }`}
                        />
                      </TableCell>
                      <TableCell >
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();   // prevent drag conflict
                            handleClick(e, row, param);
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </SortableRow>
                  ))}
                </SortableContext>
              </DndContext>
            )}

            {/* -------- PHASE TABLES (FIXED) -------- */}
            {phase.tables?.length > 0 &&
              phase.tables.map((table) => (
                <React.Fragment key={table.table_name}>
                  <TableRow sx={{ backgroundColor: "#f0f2f5" }}>
                    {/* <TableCell /> */}
                    <TableCell
                      colSpan={12}
                      sx={{ fontWeight: "bold" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SubdirectoryArrowRightIcon sx={{ mr: 1 }} />
                        Table - {table.table_name}
                      </div>
                    </TableCell>
                  </TableRow>

                  {table.parameters?.length > 0 && (
                    <DndContext
                      collisionDetection={closestCenter}
                      onDragEnd={(event) =>
                        handleDragEnd(
                          event,
                          row.unit_op_id,
                          "table",
                          phase.phase_name,
                          table.table_name
                        )
                      }
                    >
                      <SortableContext
                        items={table.parameters.map(
                          (p) => p.parameter_id
                        )}
                        strategy={verticalListSortingStrategy}
                      >
                        {table.parameters.map((param) => (
                          <SortableRow
                            key={param.parameter_id}
                            id={param.parameter_id}
                          >
                            <TableCell />
                            <TableCell />
                            <TableCell>
                              {row.unit_op_name}
                            </TableCell>
                            <TableCell>
                              {param.parameter_name}
                            </TableCell>
                            <TableCell>
                              {param.unit_of_measure}
                            </TableCell>
                            <TableCell>
                              {param.parameter_class}
                            </TableCell>
                            <TableCell>
                              {param.source_system}
                            </TableCell>
                            <TableCell>
                              {param.data_type}
                            </TableCell>
                            <TableCell sx={{ fontSize: 14 }}>
                              {param.description ? (
                                <Tooltip
                                  title={
                                    <Typography sx={{ fontSize: 13, maxWidth: 300 }}>
                                      {param.description}
                                    </Typography>
                                  }
                                  arrow
                                  placement="top"
                                  slotProps={{
                                    tooltip: {
                                      sx: {
                                        backgroundColor: "#f5f5f5",   // light background
                                        color: "#333",               // dark text
                                        border: "1px solid #e0e0e0",
                                        boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                                      },
                                    },
                                    arrow: {
                                      sx: {
                                        color: "#f5f5f5",
                                      },
                                    },
                                  }}
                                >
                                  <DescriptionOutlinedIcon
                                    sx={{
                                      fontSize: 20,
                                      color: "#9e9e9e",
                                      cursor: "pointer",
                                      "&:hover": { color: "#1976d2" },
                                    }}
                                  />
                                </Tooltip>
                              ) : (
                                "-"
                              )}
                            </TableCell>
                            <TableCell sx={{ fontSize: 14 }}>
                              <Chip
                                label={param.status}
                                className={`status-chip ${param.status?.includes("active")
                                  ? "status-chip-color-green"
                                  : "status-chip-color-gray"
                                  }`}
                              />
                            </TableCell>
                            <TableCell >
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();   // prevent drag conflict
                                  handleClick(e, row, param);
                                }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            </TableCell>


                          </SortableRow>
                        ))}
                      </SortableContext>
                    </DndContext>
                  )}
                </React.Fragment>
              ))}
          </React.Fragment>
        ))}

    </>
  );

  return (
    <Box width="100%">
      <TableContainer
        component={Paper}
        overflow="auto"
        className="process-new-table-container"
        sx={{ scrollbarGutter: "stable" }}
      >
        <Table stickyHeader>
          <TableHead position="sticky" top={0} className="table-header">
            <TableRow>
              <TableCell className="table-header-cell" sx={{ width: "60px" }} />
              <TableCell className="table-header-cell">
                Product
              </TableCell>
              <TableCell className="table-header-cell">
                Manufacturing Site
              </TableCell>
              <TableCell className="table-header-cell">
                Unit Operation
              </TableCell>
              <TableCell className="table-header-cell">
                Parameter Name
              </TableCell>
              <TableCell className="table-header-cell">
                Unit of Measure
              </TableCell>
              <TableCell className="table-header-cell">Class</TableCell>
              <TableCell className="table-header-cell">Source</TableCell>
              <TableCell className="table-header-cell">Data Type</TableCell>
              <TableCell className="table-header-cell">Description</TableCell>
              <TableCell className="table-header-cell">Status</TableCell>
              <TableCell className="table-header-cell" align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{
            "& .MuiTableRow-root": { height: 48 },
            "& .MuiTableCell-root": { py: 0.5 },
          }}>
            {tableData?.map((row) => (
              <React.Fragment key={row.unit_op_id}>
                <TableRow>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={() => toggleExpand(row.unit_op_id)}
                    >
                      {openRow === row.unit_op_id ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>{row.product_name}</TableCell>
                  <TableCell>{row.site_name}</TableCell>
                  <TableCell>{row.unit_op_name}</TableCell>
                  <TableCell colSpan={6} />
                 <TableCell sx={{ fontSize: 14 }}>   <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleApprove(row)}
                      disabled={row.approved_status === "APPROVED"}
                      startIcon={
                        row.approved_status === "APPROVED"
                        ? <CheckIcon />
                        : <HourglassEmptyIcon />
                      }
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        backgroundColor: row.approved_status === "APPROVED" ? "#2e7d32" : "#0B4C90",
                        "&:hover": {
                          backgroundColor: row.approved_status === "APPROVED" ? "#256628" : "#08386a",
                        },
                      }}
                    >
                      {row.approved_status === "APPROVED" ? "Approved" : "Approve"}
                    </Button></TableCell>
                  {/* <TableCell /> */}
                  <TableCell align="right">
                    <IconButton sx={{ cursor: 'pointer' }}>
                      <VisibilityIcon onClick={() => onVisibilityClick(row)} />
                    </IconButton>
                  </TableCell>
                </TableRow>

                {openRow === row.unit_op_id &&
                  renderGroupedSections(row)}
              </React.Fragment>
            ))}
            {!data?.loading && data?.data?.results?.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  <Label color="textSecondary" text={"No data found"}></Label>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Menu
          open={open}
          onClose={() => setMenuPosition(null)}
          anchorReference="anchorPosition"
          anchorPosition={
            menuPosition
              ? { top: menuPosition.mouseY, left: menuPosition.mouseX }
              : undefined
          }
        >
          <MenuItem
            onClick={() => {
              handleMenuOption("update", selectedRow);
              setMenuPosition(null);
            }}
          >
            Update
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleMenuOption("delete", selectedRow);
              setMenuPosition(null);
            }}
          >
            Delete
          </MenuItem>
          {/* <MenuItem
            onClick={() => {
              handleMenuOption("restore", selectedRow);
              setMenuPosition(null);
            }}
          >
            Restore
          </MenuItem> */}
        </Menu>
      </TableContainer>
    </Box>
  );
}
